import "./index.scss"
import cn from "classnames"

interface Props {
  onClick: () => void
  children: React.ReactNode
  styles?: React.CSSProperties
  className?: string
  variant?: "primary"
  isSelected?: boolean
  isDisabled?: boolean
  [key: string]: unknown
}

// PEOPLE-ROW-PILLS 2026-07-05 (QJ verification bug): callers (SubTitleContent's Invite pill)
// started passing `data-testid`/aria attributes for test hooks -- this component silently
// dropped every prop it didn't explicitly destructure, so those attributes never reached the
// DOM button. `...rest` forwards them through untouched.
const ActionButton = ({
  onClick,
  children,
  styles,
  className,
  variant,
  isSelected,
  isDisabled,
  ...rest
}: Props) => {
  return (
    <button
      onClick={onClick}
      disabled={isDisabled}
      className={cn("people-action-button", className, {
        "people-action-button-primary": variant === "primary",
        "people-action-button-selected": isSelected,
        "people-action-button-disabled": isDisabled,
      })}
      style={styles}
      {...rest}>
      {children}
    </button>
  )
}

export default ActionButton
